/** Shared placement for glyphs on a circular zodiac ring. */
export function zodiacGlyphPosition(index, radius) {
  const angle = (index / 12) * Math.PI * 2 - Math.PI / 2;
  return {
    left: `calc(50% + ${Math.cos(angle) * radius}px)`,
    top: `calc(50% + ${Math.sin(angle) * radius}px)`,
    transform: "translate(-50%, -50%)",
  };
}
